<div class="header-container">
  <div class="logo-container">
    <a
      href="#"
      class="sidebar-toggle"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
      (click)="toggleSidebar()">
      <nb-icon [icon]="(materialTheme$ | async) ? 'menu-outline' : 'menu-2-outline'"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()"><img src="assets/logo/duck-admin-dark.png" height="25px"></a>
    <span class="ms-4 mt-2 text-muted">v{{version}}</span>

  </div>
</div>

<div class="header-container">
  <nb-actions size="small">
<!--    <nb-action class="control-item">-->
<!--      <nb-search type="rotate-layout" matRipple [matRippleUnbounded]="true" [matRippleCentered]="true"></nb-search-->
<!--    ></nb-action>-->
<!--    <nb-action-->
<!--      class="control-item"-->
<!--      icon="email-outline"-->
<!--      matRipple-->
<!--      [matRippleUnbounded]="true"-->
<!--      [matRippleCentered]="true"></nb-action>-->
<!--    <nb-action-->
<!--      class="control-item"-->
<!--      icon="bell-outline"-->
<!--      matRipple-->
<!--      [matRippleUnbounded]="true"-->
<!--      [matRippleCentered]="true"></nb-action>-->

<!--    <nb-action  class="company-name"-->
<!--                matRipple-->
<!--                [matRippleUnbounded]="true"-->
<!--                [matRippleCentered]="true"-->
<!--                *ngIf="authService.getCurrentUser().role != 'super-admin' && merchantService.getCurrentMerchant()" (click)="changeMerchant()">-->
<!--&lt;!&ndash;      {{ merchantService.getCurrentMerchant().companyName }}&ndash;&gt;-->
<!--&lt;!&ndash;       (<span>{{ merchantService.getCurrentMerchant().companyRegNo }}</span>)&ndash;&gt;-->
<!--      <nb-user class="nb-user-primary" [onlyPicture]="userPictureOnly" [name]="merchantService.getCurrentMerchant().companyName" [picture]="user?.picture">-->
<!--      </nb-user>-->
<!--    </nb-action>-->

    <nb-action
      class="user-action"
      *nbIsGranted="['view', 'user']"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
      [matMenuTriggerFor]="menu">
      <nb-user class="nb-user-primary" [onlyPicture]="userPictureOnly" [name]="merchant" [picture]="merchantLogo">
        <mat-menu #menu="matMenu" xPosition="before" class="custom-menu">
          <button mat-menu-item *ngIf="canChangeMerchant()" disabled="true">
            <i class="bi bi-person-circle mr-2"></i>
            <span class="small">{{ username }}

            </span>
          </button>
          <button mat-menu-item (click)="changeMerchant()" *ngIf="canChangeMerchant()">
            <i class="bi bi-toggles2 mr-2"></i>
            <span class="small">Switch Account</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="logout()">
            <i class="bi bi-box-arrow-in-right mr-2 text-danger"></i>
            <span class="small text-danger">Log Out</span>
          </button>
        </mat-menu>
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
